import React from 'react';
import styled from 'styled-components';
import { Container, Button } from '../../styles/GlobalStyles';
import { restaurantInfo } from '../../data/menuData';
import { Instagram, Mail, Phone as PhoneIcon } from 'lucide-react';

const FooterSection = styled.footer`
  background: ${props => props.theme.colors.background};
  padding: 4rem 0 2rem;
`;





const ContactSection = styled.section`
  text-align: center;
  padding: 2rem 0;
  border-top: 1px solid #3a3a3a;
`;

const ContactTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 1rem;
  
  .visit {
    background: ${props => props.theme.colors.gradients.primary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .destination {
    background: ${props => props.theme.colors.gradients.secondary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

const ContactInfo = styled.div`
  margin-bottom: 2rem;
`;

const Address = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: ${props => props.theme.colors.text.primary};
`;

const Hours = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  color: ${props => props.theme.colors.text.secondary};
`;

const Phone = styled.div`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${props => props.theme.colors.text.secondary};
  margin-bottom: 2rem;
`;

const SocialMedia = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin: 1.5rem 0;
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 215, 0, 0.2);
  border-radius: 12px;
  color: #FFD700;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.2s ease;
  
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: rgba(255, 215, 0, 0.1);
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 215, 0, 0.2);
    }
  }
  
  &:active {
    transform: translateY(0);
    background: rgba(255, 215, 0, 0.15);
  }
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    padding: 0.6rem 0.8rem;
  }
`;

const FinalCTA = styled(Button)`
  font-size: 1.125rem;
  padding: 1rem 2rem;
`;

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #3a3a3a;
  color: ${props => props.theme.colors.text.muted};
  font-size: 0.875rem;
`;

const Footer: React.FC = () => {
  return (
    <FooterSection id="contact">
      <Container>
        <ContactSection>
          <ContactTitle>
            <span className="visit">VISIT</span> <span className="destination">DETROIT'S #1 BURGER DESTINATION</span>
          </ContactTitle>
          
          <ContactInfo>
            <Address>{restaurantInfo.address}</Address>
            <Hours>
              {Object.entries(restaurantInfo.hours).map(([days, hours]) => (
                <div key={days}>
                  <strong>{days}:</strong> {hours}
                </div>
              ))}
            </Hours>
            <Phone>Phone: {restaurantInfo.phone}</Phone>
          </ContactInfo>

          <SocialMedia>
            <SocialLink href="https://www.instagram.com/royalewithcheese313" target="_blank" rel="noopener noreferrer">
              <Instagram size={20} />
              @royalewithcheese313
            </SocialLink>
            <SocialLink href="mailto:royalewithcheese313@gmail.com">
              <Mail size={20} />
              Email Us
            </SocialLink>
            <SocialLink href="tel:+13133153014">
              <PhoneIcon size={20} />
              Call Store
            </SocialLink>
          </SocialMedia>
          
          <FinalCTA variant="primary" size="large">
            Order Now for Pickup or Delivery
          </FinalCTA>
        </ContactSection>

        <Copyright>
          © 2024 Royale with Cheese. All rights reserved. | Detroit's #1 Burger Destination
        </Copyright>
      </Container>
    </FooterSection>
  );
};

export default Footer; 